export const VOLUNTEER_URL = 'https://www.google.com/forms/about/'
export const FORM_API_URL = 'https://getform.io/f/e8c5c571-091d-439d-bb6b-59a84977279f'
